import createReducer from "./createReducer";
import * as types from "../constants/ActionTypes";
import { ActionPayload, ID } from "../../types";
import { Reducer } from "redux";
import {
  AddPackagedPayload,
  RemovePackagedPayload,
} from "../actions/packagedActions";

export interface PackagedState {
  byId: {
    [key: ID]: { id: ID; fromId: ID };
  };
  allIds: ID[];
}
type PackagedReducer<T> = Reducer<PackagedState, ActionPayload<T>>;
const packagedInitialState = { byId: {}, allIds: [] };

const addPackaged: PackagedReducer<AddPackagedPayload> = (state, action) => {
  if (!state) return packagedInitialState;
  const { payload } = action;
  const { id, fromId } = payload;

  return {
    byId: { ...state.byId, [id]: { id, fromId } },
    allIds: [...state.allIds, id],
  };
};

const removePackaged: PackagedReducer<RemovePackagedPayload> = (
  state,
  action
) => {
  if (!state) return packagedInitialState;
  const { payload } = action;
  const { id } = payload;

  const { [id]: value, ...theRest } = state.byId;
  const filtered = state.allIds.filter((el) => el !== id);
  return {
    byId: { ...theRest },
    allIds: [...filtered],
  };
};

const packagedReducer = createReducer<PackagedState>(packagedInitialState, {
  [types.ADD_PACKAGED]: addPackaged,
  [types.REMOVE_PACKAGED]: removePackaged,
});
export default packagedReducer;
